if (!customElements.get('subscription-widget')) {
  customElements.define(
    'subscription-widget',
    class SubscriptionWidget extends HTMLElement {
      constructor() {
        super();
        this.initElements();
        this.sellingPlanFormInput;
        if (!this.form.querySelector('input[name="selling_plan"]')) {
          this.sellingPlanFormInput = document.createElement('input');
          this.sellingPlanFormInput.setAttribute('type', 'hidden');
          this.sellingPlanFormInput.setAttribute('name', 'selling_plan');
          this.sellingPlanFormInput.setAttribute('value', '');
          this.form.appendChild(this.sellingPlanFormInput);
        } else {
          this.sellingPlanFormInput = this.form.querySelector('input[name="selling_plan"]');
          this.sellingPlanFormInput.setAttribute('value', '');
        }
        this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
        this.sectionId = this.dataset.sectionId;
        this.variantChangeHandler = this.handleVariantChange.bind(this);
      }

      initElements() {
        this.purchaseTypes = this.querySelectorAll('input[name="purchase_type"]');
        this.sellingPlanSelect = this.querySelector('select');
        this.form = this.closest('section').querySelector('product-form form[action*="/cart/add"]');
        this.addButton = this.form.querySelector('[name="add"]');
      }

      connectedCallback() {
        this.addEventListeners();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      addEventListeners() {
        this.purchaseTypes.forEach((input) => {
          input.addEventListener('change', this.handleSellingPlanInput.bind(this));
        });
        if (this.sellingPlanSelect) {
          this.sellingPlanSelect.addEventListener('change', this.handleSellingPlanInputChange.bind(this));
        }

        // Ecouter le changement de variant pour rafraichir le widget (Normalement déjà mis dans le thème sinon a rajouter aussi)
        this.removeEventListener('variantChange', this.variantChangeHandler);
        this.addEventListener('variantChange', this.variantChangeHandler);
      }

      removeEventListeners() {
        this.removeEventListener('variantChange', this.variantChangeHandler);
      }

      handleVariantChange(event) {
        this.currentVariant = event.detail.variant;
        // Render le widget dans global.js si thème dawn
        //this.renderSubscriptionWidget();
      }

      async renderSubscriptionWidget() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            if (this.currentVariant.id !== requestedVariantId) return;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const destination = document.getElementById(`subscriptions-widget-${this.dataset.section}`);
            const source = html.getElementById(`subscriptions-widget-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
            }
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          });
      }

      handleSellingPlanInputChange(e) {
        this.updateSubscribePrices(e);
        this.handleSellingPlanInput(e);

        // Compatibilité avec Deployer Variant Builder 👇🏻
        this.dispatchEvent(new CustomEvent('SubscriptionWidgetChanged'));
        this.updateMainPrices();
        // Compatibilité avec Deployer Variant Builder 👆🏻
      }

      handleSellingPlanInput(e) {
        if (e.target.tagName === 'INPUT' && e.target.value === 'subscription') {
          const sellingPlanId = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex].dataset.value;
          this.sellingPlanFormInput.value = sellingPlanId;
        } else if (e.target.tagName === 'INPUT' && e.target.value === 'one-time') {
          this.sellingPlanFormInput.removeAttribute('value');
        } else if (e.target.tagName === 'SELECT') {
          if (this.querySelector('input[name="purchase_type"]:checked').value === 'subscription') {
            const sellingPlanId = this.sellingPlanSelect.options[this.sellingPlanSelect.selectedIndex].dataset.value;
            this.sellingPlanFormInput.value = sellingPlanId;
          }
        }

        // Compatibilité avec Deployer Variant Builder 👇🏻
        this.dispatchEvent(new CustomEvent('SubscriptionWidgetChanged'));
        this.updateMainPrices();
        // Compatibilité avec Deployer Variant Builder 👆🏻
      }

      updateSubscribeSavingPercentage(finalPrice) {
        const savingPercentageContainers = this.querySelectorAll('.sw-dynamic-discount');
        const variantPrice = this.currentVariant.price / 100;
        if (!savingPercentageContainers || variantPrice === finalPrice) return;
        savingPercentageContainers.forEach((container) => {
          const saving = ((variantPrice - finalPrice) / variantPrice) * 100;
          container.innerText = Math.round(saving);
        });
      }

      updateSubscribePrices(e) {
        const priceContainer = this.querySelector('.sw-subscription-purchase--price');
        const selectedOption = e.target.options[e.target.selectedIndex];
        const adjustementType = selectedOption.dataset.ajustmentType;
        const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);

        const formatPrice = (value) => {
          const formatted = Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value);
          return formatted.replace(/\s/g, ''); // Enlève les espaces insécables
        };

        let adjustedPrice;

        switch (adjustementType) {
          case 'fixed_amount':
            adjustedPrice = (this.currentVariant.price - adjustementValue) / 100;
            break;
          case 'percentage':
            adjustedPrice = (this.currentVariant.price * (1 - adjustementValue / 100)) / 100;
            break;
          case 'price':
            adjustedPrice = adjustementValue / 100;
            break;
          default:
            adjustedPrice = this.currentVariant.price / 100;
            break;
        }

        priceContainer.innerText = formatPrice(adjustedPrice);
        this.updateSubscribeSavingPercentage(adjustedPrice);
      }

      updateMainPrices() {
        var total = '';
        var discountedTotal = '';
        if (this.querySelector('input[name="purchase_type"]:checked').value == 'one-time') {
          if (this.querySelector('.sw-one-time-purchase--price s')) {
            total = this.querySelector('.sw-one-time-purchase--price s').innerHTML;
            discountedTotal = this.querySelector('.sw-one-time-purchase--price span').innerHTML;
          } else {
            total = this.querySelector('.sw-one-time-purchase--price').innerHTML;
            discountedTotal = total;
          }
        } else {
          total = this.querySelector('.sw-subscription-purchase--compare-price').innerHTML;
          discountedTotal = this.querySelector('.sw-subscription-purchase--price').innerHTML;
        }

        // Specifically developped for Dawn Themes:
        this.closest('.product__info-wrapper')
          .querySelectorAll('.price__container')
          .forEach((priceContainer) => {
            if (total != discountedTotal) {
              priceContainer.closest('.price').classList.add('price--on-sale');
              priceContainer.querySelector('.price__sale .price-item--regular').innerHTML = total;
              priceContainer.querySelector('.price__sale .price-item--sale').innerHTML = discountedTotal;
            } else {
              priceContainer.closest('.price').classList.remove('price--on-sale');
              priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = total;
            }
          });
      }
    }
  );
}
